import { Directive } from '@angular/core';

@Directive({
	selector: `[flx-dialog-content], flx-dialog-content, [flxDialogContent]`,
	host: { class: 'flx-dialog-content' }
})
export class DialogContentDirective {}
